import { useEffect } from 'react'
import { DashboardTypes } from 'features/Codes'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import {
  fetchAdGroups,
  hideAdGroupSelect,
  setAdGroupId,
  setCampaignId,
} from 'features/dashboard/operation/adGorupSelect/adGroupSelectSlice'
import { DashboardTypeNames } from 'features/dashboard/utils/hooks/useDashboardTypeName'
import { Modal } from 'components/dialog/Modals'
import { ConfirmModal } from 'components/dialog/ModalTemplate'
import PropTypes from 'prop-types'
import SelectBox from 'components/form/SelectBox'
import Loading from 'components/loading/Loading'

const AdGroupSelectModal = ({
  type = DashboardTypes.KEYWORD,
  handleCreate,
}) => {
  const dispatch = useDispatch()
  const {
    visible,
    isSubmitting,
    campaignId,
    adGroupId,
    campaigns,
    adGroups,
    campaignLoading,
    adGroupLoading,
  } = useSelector(
    ({ dashboard }) => dashboard.operation.adGroupSelect,
    shallowEqual
  )

  const name = DashboardTypeNames[type]

  const handleClose = () => {
    dispatch(hideAdGroupSelect())
  }

  useEffect(() => {
    if (campaignId) {
      dispatch(fetchAdGroups(campaignId))
    }
  }, [campaignId, dispatch])

  useEffect(
    () => () => {
      dispatch(hideAdGroupSelect())
    },
    [dispatch]
  )

  const emptyCampaign = !campaignLoading && campaigns.length === 0
  const emptyAdGroup = !adGroupLoading && adGroups.length === 0

  return (
    <Modal on={visible} className="create_layer">
      <ConfirmModal
        title={`${name} 만들기`}
        confirmDisabled={
          isSubmitting || adGroupId === null || campaignId === null
        }
        handleClose={handleClose}
        onConfirm={() => handleCreate({ campaignId, adGroupId })}>
        <p className="desc_copy">
          선택한 캠페인/광고그룹내 {name}가 생성 됩니다.
        </p>
        <div className="box_subcard">
          <strong className="tit_subcard">캠페인</strong>
          {campaignLoading ? (
            <div className="opt_select" style={{ height: 34 }}>
              <Loading />
            </div>
          ) : (
            <SelectBox
              value={campaignId}
              onValueChange={v => dispatch(setCampaignId(v))}
              placeholder="캠페인 선택">
              {emptyCampaign ? (
                <SelectBox.Item value={null} text="캠페인 선택">
                  캠페인이 없습니다.
                </SelectBox.Item>
              ) : (
                campaigns.map(campaign => (
                  <SelectBox.Item key={campaign.id} value={campaign.id}>
                    {campaign.name}
                  </SelectBox.Item>
                ))
              )}
            </SelectBox>
          )}
          <strong className="tit_subcard">광고그룹</strong>
          {adGroupLoading ? (
            <div className="opt_select" style={{ height: 34 }}>
              <Loading />
            </div>
          ) : (
            <SelectBox
              value={adGroupId}
              disabled={campaignId === null}
              onValueChange={v => dispatch(setAdGroupId(v))}
              placeholder="광고그룹 선택">
              {emptyAdGroup ? (
                <SelectBox.Item value={null} text="광고그룹 선택">
                  광고그룹이 없습니다.
                </SelectBox.Item>
              ) : (
                adGroups.map(adGroup => (
                  <SelectBox.Item key={adGroup.id} value={adGroup.id}>
                    {adGroup.name}
                  </SelectBox.Item>
                ))
              )}
            </SelectBox>
          )}
        </div>
      </ConfirmModal>
    </Modal>
  )
}
AdGroupSelectModal.propTypes = {
  type: PropTypes.oneOf([DashboardTypes.KEYWORD, DashboardTypes.CREATIVE]),
  handleCreate: PropTypes.func.isRequired,
}
export default AdGroupSelectModal
